import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const authService = inject(AuthService);
  const router = inject(Router);
  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        toastService.addError({
          detail: 'Unauthorized',
        });
        authService.removeUserData();
        router.navigate(['/auth/login']);
      } else if (error.status === 403) {
        toastService.addError({
          detail: 'Access forbidden',
        });
      } else if (error.status === 404) {
        toastService.addWarn({
          detail: 'Resource not found',
        });
      } else if (error.status === 500) {
        toastService.addError({
          detail: 'Internal server error',
        });
      }

      const err = error.error;
      return throwError(() => err);
    }),
  );
};
